import React from 'react';
import { connect } from 'react-redux';
import queryString from 'query-string';
import { Button } from 'react-bootstrap';

import { billingItemForm, billingItems, modals } from 'ducks';
import { filterDuck } from 'utils/duckify';
import { formatDate } from 'utils';
import ModalComponent from 'components/ModalComponent';

// Shared functions for launching the billing item editing modals
export const addItem = (type, args) => {
  const {
    billingAccountId, contactId, dispatch, location
  } = args;

  dispatch(billingItemForm.actions.load({
    type,
    billing_account_id: billingAccountId,
    billing_item_amounts: [{ id: `amount-${Math.random()}` }]
  }));

  dispatch(modals.actions.show('BillingItemEditor', {
    billingAccountId,
    payerContactId: contactId,
    type,
    queryParams: location.search
  }));
};

export const editItem = (item, args) => {
  const {
    billingAccountId, contactId: payerContactId, dispatch, location
  } = args;

  dispatch(billingItemForm.actions.load(item));
  dispatch(modals.actions.show('BillingItemEditor', {
    billingAccountId,
    payerContactId,
    type: item.type,
    edit: true,
    queryParams: location.search
  }));
};

export const reverseItem = (item, args) => {
  const { billingAccountId, contactId: payerContactId, dispatch, location } = args;

  dispatch(billingItemForm.actions.loadOpposite(item));

  dispatch(modals.actions.show('BillingItemEditor', {
    billingAccountId,
    payerContactId,
    type: 'charge',
    queryParams: location.search
  }));
};

export const editInstallments = (args) => {
  const { billingAccountId, contactId: payerContactId, dispatch } = args;
  dispatch(modals.actions.show('InstallmentEditor', {
    billingAccountId,
    payerContactId
  }));
};

export const deleteItem = (item, args) => {
  const {billingAccountId, dispatch} = args;
  dispatch(modals.actions.show('ConfirmDelete', {item, billingAccountId, location}));
}

export const repostItem = (item, args) => {
  const { billingAccountId, contactId: payerContactId, dispatch, location, reload } = args;

  dispatch(billingItemForm.actions.loadCopy(item));

  dispatch(modals.actions.show('BillingItemEditor', {
    billingAccountId,
    payerContactId,
    type: item.type,
    queryParams: location.search,
    repost: true,
    reload
  }));
};

export const sendStatement = (args) => {
  const { billingAccountId, dispatch } = args;
  dispatch(modals.actions.show('SendStatement', { billingAccountId }));
};

export const ConfirmDelete = connect()(({dispatch, item, billingAccountId, location, deleting = false}) => {
  const buttons = [
    <button className="btn btn-danger"
            disabled={deleting}
            onClick={() => {
              dispatch(modals.actions.update({deleting: true}));
              dispatch(billingItems.actions.remove(item))
                .then(() => dispatch(modals.actions.hide()))
                .then(() => dispatch(filterDuck(billingItems, {
                  billing_account_id: billingAccountId,
                  page: 1, ...queryString.parse(location.search)
                }).actions.load()))
                .catch((res) => {
                  dispatch(modals.actions.hide())
                  dispatch(modals.actions.show('UnexpectedError', { message: res.error }))
                  dispatch(billingItems.actions.markDirty())
                });
            }}>{deleting ? 'Deleting...' : 'Delete'}</button>
  ];
  return (
    <ModalComponent title="Confirm Delete"
                    buttons={buttons}
                    closeText="Cancel">
      <p>Are you sure you want to delete <em>{formatDate(item.billing_date)} {item.description}</em>?</p>
    </ModalComponent>);
});

export const UnexpectedError = connect()(({dispatch}) =>
  <ModalComponent title="Oops!"
                  buttons={[<button className="btn btn-danger"
                                    onClick={() => dispatch(modals.actions.hide())}>OK</button>]}>
    <p>We're sorry, something went wrong. Please reload the page and try again.</p>
  </ModalComponent>);

export const MissingEmail = connect()(() =>
  <ModalComponent title="Email Not Sent">
    <p>Sorry, the account owner does not have an email address.</p>
  </ModalComponent>
);

export const SendStatement = connect()(({dispatch, billingAccountId, sending = false}) => {
  const sendStatement = () => {
    const token = $('meta[name="csrf-token"]').attr('content');
    fetch(`/api/billing_accounts/${billingAccountId}/send_statement`, {
      method: 'POST',
      headers: {'X-CSRF-Token': token},
      credentials: 'same-origin'
    }).then(response => {
      dispatch(modals.actions.hide());
      if (response.ok) {
        Utility.successMessage('Email sent.');
      } else if (response.status === 422) {
        dispatch(modals.actions.show('MissingEmail'));
      } else {
        dispatch(modals.actions.show('UnexpectedError'));
      }
    });

    dispatch(modals.actions.update({sending: true}));
  };

  return <ModalComponent title="Send Statement"
                         closeText="Cancel"
                         buttons={[
                           <Button variant="primary"
                                   onClick={sendStatement}
                                   disabled={sending}>{sending ? 'Sending...' : 'Send'}</Button>]}>
    <p>Send an email to the account owner notifying them of a change to their statement?</p>
  </ModalComponent>;
});
